/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const headerStyle = {
  headerInner: (theme: Theme) => ({
    justifyContent: "space-between",
    top: 0,
    left: 0,
    right: 0,
    width: "100%",
    /* -1px because of the borderBottom, so that mouseenter and leave function correctly and flyouts stay open  */
    marginBottom: "-1px",
    [theme.breakpoints.up("lg")]: {
      paddingInline: "1rem",
    },
  }),
  brand: (theme: Theme) => ({
    justifyContent: "center",
    minHeight: "4rem",
    [theme.breakpoints.up("md")]: {
      minHeight: "5rem",
    },
  }),
  brandLogo: {
    display: "block", // So that there is no spacing under the svg, this reults as not beeing threaded as inline text element
  },
  actions: {
    alignItems: "center",
  },
};
